import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { Box, IconButton, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';
import { defineMessage, useIntl } from 'react-intl';
const removeFilterMessage = defineMessage({
  id: 'common.removeFilter',
  defaultMessage: 'Quitar filtro',
});

export interface RemovableFilterSlotProps {
  onRemove: () => void;
  children: ReactNode;
  sx?: SxProps<Theme>;
}

/**
 * Wraps an addable filter with an external remove button.
 * The inner clear (x) in inputs only clears the value; this button removes the entire filter from the bar.
 */
export function RemovableFilterSlot({ onRemove, children, sx }: RemovableFilterSlotProps) {
  const { $t } = useIntl();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        ...sx,
      }}
    >
      {children}
      <IconButton
        aria-label={$t(removeFilterMessage)}
        onClick={onRemove}
        size="small"
        color="secondary"
        sx={{ flexShrink: 0, ml: '-2px' }}
      >
        <RemoveCircleOutlineIcon sx={{ fontSize: '14px' }} />
      </IconButton>
    </Box>
  );
}
